import React, { useState, useEffect, useCallback } from 'react';
import { path, propOr, isEmpty } from 'ramda';
import { useQuery } from '@apollo/react-hooks';
import { GET_JOB } from '../apollo/queries';
import { Mutation } from 'react-apollo';
import { CREATE_CANDIDATE } from '../apollo/mutation';
import {
  Page,
  Layout,
  Badge,
  TextStyle,
  Button,
  Card,
  AppProvider,
  Subheading,
  Heading,
  DropZone,
  Form,
  FormLayout,
  TextField,
  ButtonGroup,
  Thumbnail,
  Stack,
  Caption,
} from '@shopify/polaris';
import '@shopify/polaris/dist/styles.css';

const Jobs = (props) => {
  let { shopifyToken, path_url, location } = props;

  const [errors, setErrors] = useState('');
  const [file, setFile] = useState();
  const [form, setState] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleDropZoneDrop = useCallback((_dropFiles, acceptedFiles, _rejectedFiles) => setFile((file) => acceptedFiles[0]), []);

  const validImageTypes = ['application/pdf', 'image/jpeg', 'image/png'];

  const fileUpload = !file && <DropZone.FileUpload actionTitle='Add resume' actionHint='or drop an file to upload' />;
  const uploadedFile = file && (
    <Stack>
      <Thumbnail
        size='small'
        alt={file.name}
        source={
          validImageTypes.indexOf(file.type) > 0
            ? window.URL.createObjectURL(file)
            : 'https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304'
        }
      />
      <div>
        {file.name} <Caption>{file.size} bytes</Caption>
      </div>
    </Stack>
  );

  const { loading, data, refetch } = useQuery(GET_JOB, {
    variables: { shopifyToken, jobId: props.match.params.id },
  });

  const job = propOr({}, 'job')(data);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateField = (name) => (value) => {
    setState({
      ...form,
      [name]: value,
    });
  };

  const changeRoute = path(['history', 'push'])(props);

  const handleFormSubmit = (props) => {
    let { createCandidate } = props;

    createCandidate({
      variables: {
        name: form.name,
        email: form.email,
        phone: form.phone,
        jobId: job.id,
        shopifyToken,
        resume: file,
      },
    })
      .then((response) => {
        if (response.data.createCandidate.errors.length !== 0) {
          alert(response.data.createCandidate.errors);
          const { data } = response;
        } else {
          changeRoute(`${location.pathname}/success`);
          const { data } = response;
        }
      })
      .catch((e) => {
        let messages = e.graphQLErrors[0].message;
        setErrors(messages);
      });
  };

  return (
    <Mutation mutation={CREATE_CANDIDATE}>
      {(createCandidate) => (
        <AppProvider>
          <Page title={job.title}>
            <Layout>
              <Layout.Section>
                <div className='Badge-Top__bar'>
                  <Badge>{job.location}</Badge>
                  <Badge>{job.category}</Badge>
                  <Badge>{job.employmentType}</Badge>
                </div>
              </Layout.Section>
              <Layout.Section>
                <div dangerouslySetInnerHTML={{ __html: job.description }} />
              </Layout.Section>

              <Layout.Section>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleFormSubmit({ createCandidate });
                  }}>
                  <Card>
                    <Card.Header title='Submit your application'></Card.Header>
                    <Card.Section>
                      <FormLayout>
                        <TextField id='name' label='Name' value={form.name} name='name' onChange={updateField('name')} />
                        <TextField
                          id='email'
                          label='Email'
                          value={form.email}
                          name='email'
                          type='email'
                          onChange={updateField('email')}
                        />
                        <TextField id='phone' label='Phone' value={form.phone} name='phone' onChange={updateField('phone')} />
                        <DropZone allowMultiple={false} onDrop={handleDropZoneDrop} label='Resume' id='resume'>
                          {uploadedFile}
                          {fileUpload}
                        </DropZone>
                      </FormLayout>
                    </Card.Section>
                  </Card>
                  <br />
                  <ButtonGroup>
                    <Button onClick={() => changeRoute(`${path_url}`)} size='large'>
                      Back to job list
                    </Button>
                    <Button primary={true} submit={true} size='large'>
                      Save
                    </Button>
                  </ButtonGroup>
                </Form>
              </Layout.Section>
            </Layout>
          </Page>
        </AppProvider>
      )}
    </Mutation>
  );
};

export default Jobs;
